module.exports = __webpack_public_path__ + "static/img/loadMore.f18b1df.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loadMore.gif
// module id = 61
// module chunks = 1